import layout from './UserDropdownMenu.html?raw';
import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import Config from '@/Management/GlobalConfiguration';
import UserDropdownMenuViewModel from '@/Components/UserDropdownMenu/UserDropdownMenuViewModel';

export default class UserDropdownMenu extends Control {
    private jQueryControl: JQuery;

    public constructor(private viewModel: UserDropdownMenuViewModel, private element?: JQuery) {
        super(viewModel, element);

        // Initiale (De-)Aktivierung des DarkMode
        if (Config.headerView.showDarkModeSwitch)
            this.toggleDarkMode();

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');
        this.applyTemplate(layout, this.jQueryControl);
        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: any): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'userDropdownMenu',

            locator: this.viewModel.locator,

            controlIdent: this.identifier,

            visible: this.viewModel.isVisible,

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            })
        });

        this.defineSubscription(this.viewModel.darkModeActive, () => this.toggleDarkMode());
    }

    private toggleDarkMode(): void {
        $(document.body).toggleClass('dark-mode', this.viewModel.darkModeActive());
    }
}

ComponentManager.setControl('UserDropdownMenu', UserDropdownMenu, 'RADPresentation.HTMLClient.DefaultViewExtensions');